import { render, staticRenderFns } from "./HomeMainCard.vue?vue&type=template&id=20b8ca06&"
import script from "./HomeMainCard.vue?vue&type=script&lang=ts&"
export * from "./HomeMainCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports